import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { DomainModifiersModule } from '@symphony-solo/domain/modifiers/src';
import { DomainPriceLevelsModule } from '@symphony-solo/domain/price-levels/src';
import { DomainTaxrateShiftsModule } from '@symphony-solo/domain/taxrate-shifts/src';
import { DomainTaxratesModule } from '@symphony-solo/domain/taxrates/src';
import { SyncDataFacade } from './+state';
import { SyncDataStateModule } from './+state/sync-data.state.module';
import { SyncDataService } from './services';

@NgModule({
  imports: [
    CommonModule,
    SyncDataStateModule,
    DomainTaxrateShiftsModule.forRoot(),
    DomainTaxratesModule.forRoot(),
    DomainModifiersModule.forRoot(),
    DomainPriceLevelsModule.forRoot(),
  ],
})
export class DomainSyncDataModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainSyncDataModule,
      providers: [SyncDataService, SyncDataFacade],
    };
  }
}
